<template>
  <div class="select-input-container">
    <label :for="selectId" :class="{ active: selectedOption }">{{ label }}</label>
    <select 
      :id="selectId" 
      v-model="selectedOption" 
      @change="handleChange"
      :disabled="isDisabled"
      :class="{ error: isRequired && !selectedOption }"
    >
      <option value="" disabled>{{ placeholder }}</option>
      <option v-for="option in options" :key="option.id" :value="option.id">{{ option.name  }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SelectInput',
  props: {
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Select an options'
    },
    
    optionName: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    isDisabled: { 
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      selectedOption: this.modelValue,
      selectId: `select-${Math.random().toString(36).substr(2, 9)}`
    };
  },
  watch: {
    modelValue(newVal) {
      this.selectedOption = newVal;
    },
    selectedOption(newVal) {
      this.$emit('update:modelValue', newVal); 
    }
  },
  methods: {
    handleChange() {
      const selectedItem = this.options.find(option => option.id === this.selectedOption);
      if (selectedItem) {
        this.$emit('selected', { id: selectedItem.id, text: selectedItem.text }); 
      }
    }
  }
};
</script>

<style scoped>
.select-input-container {
  position: relative;
  margin-top: 20px;
}

select {
  border: 1px solid var(--input-border-color);
  border-radius: 4px;
  padding: 10px;
  font-size: 0.85rem;
  outline: none;
  width: 100%;
  height: 40px;
  transition: border-color 0.3s;
}

select:focus {
  border-color: var(--logo-color);
}

label {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 5px;
  display: block;
  color: var(--input-text-color);
}
</style>
